import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * gets the list of leads users
 */
export async function getLeadsUsers({
    projectId,
    type = 'all',
    limit = 10,
    page = 1,
}) {
    if (isAuthenticated()) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_V2}/sponsor/leads?projectId=${projectId}&limit=${limit}&type=${type}&page=${page}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.json();
    }
    return null;
}
export async function updateActivation({ projectId, id, status }) {
    if (isAuthenticated()) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_V2}/sponsor/leads/${id}/${status}?projectId=${projectId}`,
            {
                method: 'PUT',
                headers: {
                },
            }
        );

        return await response.json();
    }
    return null;
}
export async function getLeadsCaptured({ projectId, page, limit }) {
    if (isAuthenticated()) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_V2}/sponsor/leads/captured?projectId=${projectId}&page=${page}&limit=${limit}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.json();
    }
    return null;
}
export async function exportLeadsCaptured({ projectId }) {
    if (isAuthenticated()) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_V2}/sponsor/leads/captured/export?projectId=${projectId}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );

        return await response.blob();
    }
    return null;
}
